import { useEffect } from 'react'
import './SparkleBurst.css'

export function SparkleBurst({ onDone }) {
  useEffect(() => {
    const t = setTimeout(() => onDone?.(), 1200)
    return () => clearTimeout(t)
  }, [onDone])

  return (
    <div className="sparkle-burst" role="presentation" aria-hidden>
      {Array.from({ length: 12 }, (_, i) => (
        <span
          key={i}
          className="sparkle-ray"
          style={{
            '--i': i,
            '--angle': `${(i / 12) * 360}deg`,
          }}
        />
      ))}
    </div>
  )
}
